function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
function withProps(Component, staticProps) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return /*#__PURE__*/React.createElement(Component, _extends({}, staticProps, props));
  };
}
export default withProps;